import React from "react";
import { contextapi } from "../helpers/contextapi";

const PageTitle = ({ title, sub }) => {
  const context = React.useContext(contextapi);

  const { user } = context.values;
  const tit = title ? title : `Welcome ${user?.firstname}`;
  document.title = `KSPD | ` + tit;
  return (
    <div className="mb-3 pb-2 border-bottom">
      <h3 className="font-weight-bold text-uppercase">{title ? title : `Welcome ${user?.firstname ? user?.firstname : "Back"}`}</h3>
      <h6 className="font-weight-normal mb-0">
        {sub ? (
          sub
        ) : (
          <span>
            Application cards are color coded, <b>White</b> background means data upload is optional, <span className="text-danger">Red</span> means
            no data uploaded, <span className="text-info">Blue</span> means partial data uploaded, and <span className="text-success">Green</span>{" "}
            means full requirement has been met
          </span>
        )}
      </h6>
    </div>
  );
};

export default PageTitle;
